<template>
<div class="chapter">
<div class="inner_page">
<p class="SP" id="ack"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="CO"><span class="cic">T</span>hanks to Tris Zeigler and Lucinda Denton for reading early versions of this manuscript and giving their wonderful feedback.</p>
<p class="FMTX">Thanks to Jack Harbison for the awesome brainstorming, which inspired me so much.</p>
<p class="FMTX">Finally, much gratitude to Jen Enderlin for giving me the chance to write this—I had so much fun!—and to Annelise Robey for cheerleading even through the roughest times.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?078731c4